var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Header extends Component {
    constructor() {
        super('Header', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('body').hasClass('home')) {
                $(window).on('scroll', () => {
                    this.spy();
                });
            }
            this.success();
        });
    }
    spy() {
        const activeImage = $('#carousel-home .carousel-item.active .home-block-image');
        if (activeImage.viewportPosition().y + activeImage.height() < $('.component-header').height()) {
            $('.component-header').addClass('bg-beige');
        }
        else {
            $('.component-header').removeClass('bg-beige');
        }
    }
}
